import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EAvailabilityStatus;
(function (EAvailabilityStatus) {
  EAvailabilityStatus["Available"] = "available";
  EAvailabilityStatus["BookedPending"] = "booked-pending";
  EAvailabilityStatus["Offered"] = "offered";
  EAvailabilityStatus["Booked"] = "booked";
  EAvailabilityStatus["BookedByIntegrator"] = "booked-by-integrator";
  EAvailabilityStatus["BookedByOffer"] = "booked-by-offer";
  EAvailabilityStatus["Expired"] = "expired";
})(EAvailabilityStatus || (EAvailabilityStatus = {}));
export let EAvailabilitySource;
(function (EAvailabilitySource) {
  EAvailabilitySource["AppointmentCancellation"] = "appointment-cancellation";
  EAvailabilitySource["Ui"] = "ui";
  EAvailabilitySource["Referral"] = "referral";
  EAvailabilitySource["Integrator"] = "integrator";
  EAvailabilitySource["Demo"] = "demo";
})(EAvailabilitySource || (EAvailabilitySource = {}));
export const fieldsAvailability = _extends({}, fieldsIBaseModel, {
  date: {
    type: 'Date'
  },
  endDate: {
    type: 'Date'
  },
  duration: {
    type: 'Number'
  },
  status: {
    type: 'Option',
    values: EAvailabilityStatus
  },
  source: {
    type: 'Option',
    values: EAvailabilitySource
  },
  createdFromAppointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  usedForAppointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  // filters: { type: 'Option', values: AvailabilityFilter },
  appointmentType: {
    type: 'ID',
    ref: EModel.AppointmentType
  },
  facility: {
    type: 'ID',
    ref: EModel.Facility
  },
  provider: {
    type: 'ID',
    ref: EModel.Provider
  },
  // externalId: { type: 'Option', values: AvailabilityExternalId },
  offer: {
    type: 'ID',
    ref: EModel.Offer
  }
  // bookingInfo: { type: 'Option', values: BookingInfo },
});